module.exports = __webpack_public_path__ + "img/icon_5_44.ea0a8a8f.png";